import React, { Component } from 'react';
import moment from 'moment';
import Pagination from 'react-js-pagination';
import LessonFloat from 'template/Floats/LessonFloat';
import Lesson from 'mediators/Lesson';
import EmptyDataPlaceholder from 'components/UI/EmptyDataPlaceholder';
import './style.scss';

class CalendarDailyView extends Component {
  constructor(props){
    super(props);
    this.state = {
      lessonEvent:{},
      showLessonFloat: false,
      currentTarget: null
    }
    this._closeFloat = this._closeFloat.bind(this);
  }
  _onLessonClick(lesson, targetRef){
    this.setState({
      lessonEvent: new Lesson(lesson)
    },()=>{
      this.setState({
        showLessonFloat: true,
        currentTarget: targetRef
      })
    })

  }
  _closeFloat() {
    this.setState({
      showLessonFloat: false,
      lessonEvent: null,
      currentTarget: null
    });
  }
  _renderPaginationToolbar(){
    const { pagination, onPageChange } = this.props; 
    const {
      activePage,
      itemsCountPerPage,
      totalItemsCount,
      pageRangeDisplayed,
    } = pagination;
    return (
      <Pagination
        activePage={activePage}
        itemsCountPerPage={itemsCountPerPage}
        totalItemsCount={totalItemsCount}
        pageRangeDisplayed={pageRangeDisplayed}
        onChange={onPageChange}
      />
    );
  }
  renderLessonList(result_list){
    const { lessonEvent, showLessonFloat, currentTarget } = this.state;
    return (
      <div>
        {
          result_list.map(lesson=>{
            let targetRef;
            return(
              <div className='lesson_container' onClick={()=>this._onLessonClick(lesson, targetRef)} ref={ref=>targetRef=ref} style={{borderLeft: `6px solid ${lesson.lCalendarColor? lesson.lCalendarColor: 'rgb(33, 150, 243)'}`}}>
                <div className='time'>{moment(lesson.lStartTime).format('HH:mm a')} - {moment(lesson.lEndTime).format('HH:mm a')}</div>
                <div className='lesson_name'>{lesson.title}</div>
              </div>
            );
          })
        }
        <LessonFloat
          lesson={lessonEvent}
          show={showLessonFloat}
          target={currentTarget}
          onCloseFloat={this._closeFloat}
        />
        {this._renderPaginationToolbar()}
      </div>
    );
  }
  render() {
    const { placeholderTitle } = this.props;
    const { result_list } = this.props.data; 
    return(
      <div className='calendar_container'>
        { result_list && result_list.length==0 &&
          <EmptyDataPlaceholder title={placeholderTitle} icon='icon-chalkboard' />
        }
        { result_list && result_list.length>0 && this.renderLessonList(result_list)}
      </div>
    );
  }
}

export default CalendarDailyView;


// WEBPACK FOOTER //
// ./src/components/UI/CalendarDailyView/index.js